import { AbstractCollection1g9uvtcheckwb as AbstractCollection } from './AbstractCollection.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import {
  MutableIterablez3x4ksk1fmrm as MutableIterable,
  Collection1k04j3hzsbod0 as Collection,
} from './Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
import { removeAll3cm9rh0qak2y6 as removeAll } from './MutableCollections.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AbstractMutableCollectionClass;
function AbstractMutableCollection() {
  if (AbstractMutableCollectionClass === VOID) {
    class $ extends AbstractCollection() {
      static n6($box) {
        return this.o6($box);
      }
      u2(elements) {
        this.p6();
        var modified = false;
        var _iterator__ex2g4s = elements.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          if (this.j2(element))
            modified = true;
        }
        return modified;
      }
      w3(elements) {
        this.p6();
        var tmp = isInterface(this, MutableIterable()) ? this : THROW_CCE();
        return removeAll(tmp, (it) => elements.t2(it));
      }
      y4() {
        this.p6();
        var iterator = this.p1();
        while (iterator.q1()) {
          iterator.r1();
          iterator.q6();
        }
      }
      toJSON() {
        return this.toArray();
      }
      p6() {
      }
    }
    initMetadataForClass($, 'AbstractMutableCollection', VOID, VOID, [MutableIterable(), Collection()]);
    AbstractMutableCollectionClass = $;
  }
  return AbstractMutableCollectionClass;
}
//region block: exports
export {
  AbstractMutableCollection as AbstractMutableCollections0bg6c40ztuj,
};
//endregion

//# sourceMappingURL=AbstractMutableCollectionJs.mjs.map
